import {styled} from '@linaria/react';
import React from 'react';
import {COLORS} from '../../../constants/colors';
import {FONT_SIZES} from '../../../constants/typography';
import {UnstyledLinkLinaria} from '../../atoms/UnstyledLink/UnstyledLinkLinaria';

interface LinkProps {
  link: {
    href: string;
    label: string;
  };
}

export const Link: React.FC<LinkProps> = ({link}) => {
  return (
    <StyledLink data-testid="Link" to={link.href}>
      {link.label}
    </StyledLink>
  );
};

const StyledLink = styled(UnstyledLinkLinaria)`
  font-size: ${FONT_SIZES.px12};
  color: ${COLORS.Grey1};
  display: block;
  line-height: 1.5rem;
`;
